export default __webpack_public_path__ + "static/media/vbb-5.ba2ba385.jpg";